import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GlassInfoModalComponent } from '../glass-info-modal/glass-info-modal.component';
import { ModalHelperService } from 'src/app/services/modal-helper';
import { GlassFilterModalComponent, GlassFilterState } from '../glass-filter-modal/glass-filter-modal.component';
import { GlassCountries } from 'src/app/utils/Constants';

type Glass = any;
@Component({
  selector: 'app-glass-bybrand-result',
  templateUrl: './glass-bybrand-result.component.html',
  styleUrls: ['./glass-bybrand-result.component.scss'],
  standalone: false,
})
export class GlassBybrandResultComponent implements OnInit {

  @Input() glasses: Glass[] = [];
  selectedGlass: Glass | null = null;
  @Input() manufacturerId: number | null = null;
  /** Pre-selected region from parent's country dropdown */
  @Input() countryId: number = 0;
  glassFilter: GlassFilterState = {
    ug: null,
    structure: null,
    lightTransmittance: null,
    gValue: null,
    category: null,
    regionId: 0,
  };
  constructor(private modalController: ModalController, private modalHelper: ModalHelperService) { }

  ngOnInit(): void {
    this.glassFilter.regionId = this.countryId ?? 0;
    console.log('Received glasses:', this.glasses.length);
  }

  get filteredGlasses(): Glass[] {
    return this.glasses.filter(glass => {
      if (glass.deleted) return false;
      if (!this.glassBelongsToRegion(glass, this.glassFilter.regionId)) return false;
      if (this.glassFilter.category && this.getCategoryValue(glass) !== this.glassFilter.category) return false;
      if (this.glassFilter.structure && glass.structure !== this.glassFilter.structure) return false;
      const ug = parseFloat(parseFloat(glass.ug).toFixed(1));
      if (this.glassFilter.ug !== null && ug > this.glassFilter.ug) return false;
      if (this.glassFilter.lightTransmittance !== null
        && glass.lightTransmittance < this.glassFilter.lightTransmittance) return false;
      if (this.glassFilter.gValue !== null
        && glass.gValue < this.glassFilter.gValue) return false;
      return true;
    });
  }

  get isFilterActive(): boolean {
    return this.glassFilter.ug !== null ||
      !!this.glassFilter.structure ||
      this.glassFilter.lightTransmittance !== null ||
      this.glassFilter.gValue !== null ||
      !!this.glassFilter.category ||
      this.glassFilter.regionId !== 0;
  }

  private glassBelongsToRegion(glass: any, regionId: number): boolean {
    if (!glass.region || !Array.isArray(glass.region)) return false;
    if (regionId === 0) return true;

    const neg = -regionId;
    let isEU = false;
    let result = false;

    for (const r of glass.region) {
      if (r === 1) isEU = true;
      if (r === regionId) result = true;
      if (r === 0) result = true;
      if (r === neg) result = false;
    }

    if (isEU && regionId !== 0) {
      const country = GlassCountries.find(c => c.id === regionId);
      if (country?.eu) result = true;
    }
    return result;
  }

  async openFilterModal(): Promise<void> {
    const modal = await this.modalController.create({
      component: GlassFilterModalComponent,
      cssClass: 'configuration-modal',
      componentProps: {
        glasses: this.glasses,
        countries: GlassCountries,
        currentFilter: { ...this.glassFilter }
      },
    });

    await modal.present();
    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm' && data?.filter) {
      this.glassFilter = data.filter;
      // Deselect if selected glass no longer visible
      if (this.selectedGlass &&
        !this.filteredGlasses.find(g => g.id === this.selectedGlass!.id)) {
        this.selectedGlass = null;
      }
    }
  }

  selectGlass(glass: Glass): void {
    this.selectedGlass = glass;
  }

  private getCategoryValue(glass: any): string {
    return glass?.category?.trim() ? glass.category.trim() : 'Other';
  }

  async showGlassInfo(glass: Glass): Promise<void> {
    const modal = await this.modalController.create({
      component: GlassInfoModalComponent,
      cssClass: 'glass-info-modal',
      componentProps: { glass }
    });
    await modal.present();
  }

  async validate() {
    if (this.selectedGlass) {
      await this.modalController.dismiss({ selectedGlass: this.selectedGlass }, 'confirm');
    }
  }
  cancel() {
    console.log("dismiss called ")
    this.modalController.dismiss(null, 'cancel');
  }

}
